import { combineSlices, configureStore } from "@reduxjs/toolkit"
import { paginationSlice } from "./pagination-slice"
import { FilterConfig, filtersSlice } from "./filters-slice"
import { Bucket, FacetConfig, facetsSlice } from "./facets-slice"
import { resultsSlice } from "./results-slice"
import { ISearchClient } from "./search-thunk"

export const reducer = combineSlices(
  paginationSlice,
  filtersSlice,
  facetsSlice,
  resultsSlice,
)

export type SearchStoreOptions = {
  searchClient: ISearchClient
  initialFilters: Record<string, { config: FilterConfig; values: any[] }>
  initialFacets: Record<string, { config: FacetConfig; buckets: Bucket[] }>
}

export function configureSearchStore({ searchClient }: SearchStoreOptions) {
  return configureStore({
    reducer,
    middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({
        thunk: { extraArgument: { searchClient } },
      })
    },
    enhancers(getDefaultEnhancers) {
      return getDefaultEnhancers({ autoBatch: { type: "tick" } })
    },
  })
}

export type SearchState = ReturnType<typeof reducer>
export type SearchStore = ReturnType<typeof configureSearchStore>
